export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      shop: "Boutique",
      sweaters: "Pulls",
      hoodies: "Hoodies",
      tshirts: "T-Shirts",
      jackets: "Vestes",
      about: "À propos",
      contact: "Contact",
      sizeGuide: "Guide des tailles",
      cart: "Panier",
      admin: "Admin"
    },
    // Hero
    hero: {
      title: "L'Élégance Équestre",
      subtitle: "Vêtements premium pour cavaliers passionnés",
      cta: "Découvrir la collection",
      freeShipping: "Livraison gratuite dès 75€"
    },
    // Products
    products: {
      featured: "Produits vedettes",
      newArrivals: "Nouveautés",
      allProducts: "Tous les produits",
      addToCart: "Ajouter au panier",
      outOfStock: "Rupture de stock",
      size: "Taille",
      color: "Couleur",
      quantity: "Quantité",
      material: "Matière",
      care: "Entretien",
      inStock: "En stock",
      price: "Prix",
      originalPrice: "Prix original",
      sale: "Promo",
      new: "Nouveau",
      filterBy: "Filtrer par",
      sortBy: "Trier par",
      priceRange: "Fourchette de prix",
      clearFilters: "Effacer les filtres",
      noProducts: "Aucun produit trouvé",
      viewDetails: "Voir détails"
    },
    // Cart
    cart: {
      title: "Votre Panier",
      empty: "Votre panier est vide",
      continueShopping: "Continuer vos achats",
      subtotal: "Sous-total",
      shipping: "Livraison",
      freeShipping: "Gratuite",
      total: "Total",
      checkout: "Passer à la caisse",
      remove: "Supprimer",
      updateQuantity: "Modifier la quantité"
    },
    // Checkout
    checkout: {
      title: "Finaliser la commande",
      customerInfo: "Informations personnelles",
      shippingAddress: "Adresse de livraison",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
      city: "Ville",
      postalCode: "Code postal",
      country: "Pays",
      belgium: "Belgique",
      france: "France",
      netherlands: "Pays-Bas",
      orderSummary: "Récapitulatif",
      placeOrder: "Confirmer la commande",
      paymentMethod: "Mode de paiement",
      qrPayment: "Paiement par QR Code",
      qrInstructions: "Scannez le QR code avec votre application bancaire pour effectuer le paiement.",
      orderConfirmed: "Commande confirmée !",
      orderNumber: "Numéro de commande",
      thankYou: "Merci pour votre commande !",
      paymentPending: "En attente de paiement",
      bankDetails: "Détails bancaires",
      reference: "Référence",
      iban: "IBAN",
      bic: "BIC",
      accountHolder: "Titulaire du compte"
    },
    // About
    about: {
      title: "Notre Histoire",
      subtitle: "Passion équestre depuis 2020",
      story: "EBB-SHOP est née de la passion pour l'équitation et le désir d'offrir aux cavaliers des vêtements alliant élégance, confort et qualité. Chaque pièce est conçue pour accompagner les cavaliers dans leur quotidien, que ce soit à l'écurie, en compétition ou en balade.",
      values: "Nos Valeurs",
      quality: "Qualité Premium",
      qualityDesc: "Matières sélectionnées avec soin pour un confort optimal.",
      passion: "Passion Équestre",
      passionDesc: "Créés par des cavaliers, pour des cavaliers.",
      eco: "Éco-responsable",
      ecoDesc: "Engagement pour une mode plus durable."
    },
    // Contact
    contact: {
      title: "Contactez-nous",
      subtitle: "Une question ? Nous sommes là pour vous aider.",
      name: "Nom",
      email: "Email",
      subject: "Sujet",
      message: "Message",
      send: "Envoyer",
      phone: "Téléphone",
      address: "Adresse",
      hours: "Horaires",
      hoursValue: "Lun-Ven: 9h-18h"
    },
    // Size Guide
    sizeGuide: {
      title: "Guide des Tailles",
      subtitle: "Trouvez votre taille idéale",
      howToMeasure: "Comment prendre vos mesures",
      chest: "Tour de poitrine",
      waist: "Tour de taille",
      hips: "Tour de hanches",
      tip: "Conseil : En cas de doute entre deux tailles, choisissez la taille supérieure pour plus de confort."
    },
    // Footer
    footer: {
      description: "Vêtements équestres de qualité pour cavaliers passionnés.",
      quickLinks: "Liens rapides",
      customerService: "Service client",
      followUs: "Suivez-nous",
      newsletter: "Newsletter",
      newsletterPlaceholder: "Votre email",
      subscribe: "S'abonner",
      rights: "Tous droits réservés",
      privacy: "Politique de confidentialité",
      terms: "Conditions générales",
      returns: "Retours & Échanges"
    },
    // Admin
    admin: {
      title: "Administration",
      dashboard: "Tableau de bord",
      products: "Produits",
      orders: "Commandes",
      settings: "Paramètres",
      paymentSettings: "Paramètres de paiement",
      siteSettings: "Paramètres du site",
      addProduct: "Ajouter un produit",
      editProduct: "Modifier le produit",
      deleteProduct: "Supprimer",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ce produit ?",
      save: "Enregistrer",
      cancel: "Annuler",
      bankName: "Nom de la banque",
      status: "Statut",
      stockAlerts: "Alertes de stock",
      lowStock: "Stock bas",
      outOfStock: "Rupture",
      orderStatus: {
        pending: "En attente",
        paid: "Payé",
        processing: "En préparation",
        shipped: "Expédié",
        delivered: "Livré",
        cancelled: "Annulé"
      }
    },
    // Auth & Account
    auth: {
      login: "Connexion",
      register: "Inscription",
      logout: "Déconnexion",
      email: "Email",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      forgotPassword: "Mot de passe oublié ?",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      createAccount: "Créer un compte",
      loginSuccess: "Connexion réussie !",
      registerSuccess: "Inscription réussie !",
      invalidCredentials: "Email ou mot de passe incorrect"
    },
    account: {
      title: "Mon Compte",
      profile: "Profil",
      orders: "Mes Commandes",
      addresses: "Adresses",
      wishlist: "Liste de souhaits",
      loyalty: "Programme Fidélité",
      editProfile: "Modifier le profil",
      addAddress: "Ajouter une adresse",
      defaultAddress: "Adresse par défaut",
      noOrders: "Vous n'avez pas encore de commandes",
      orderDetails: "Détails de la commande"
    },
    // Loyalty
    loyalty: {
      title: "Programme Fidélité",
      points: "Points",
      level: "Niveau",
      bronze: "Bronze",
      silver: "Argent",
      gold: "Or",
      discount: "Réduction",
      pointsToNext: "Points pour le niveau suivant",
      earnPoints: "Gagnez 1 point par euro dépensé",
      benefits: "Avantages",
      bronzeBenefit: "Accès aux offres exclusives",
      silverBenefit: "5% de réduction sur toutes les commandes",
      goldBenefit: "10% de réduction + livraison gratuite"
    },
    // Wishlist
    wishlist: {
      title: "Ma Liste de Souhaits",
      empty: "Votre liste de souhaits est vide",
      addedToWishlist: "Ajouté à la liste de souhaits",
      removedFromWishlist: "Retiré de la liste de souhaits",
      moveToCart: "Ajouter au panier"
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Une erreur est survenue",
      success: "Succès",
      close: "Fermer",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      search: "Rechercher",
      language: "Langue"
    },
    // Chatbot
    chatbot: {
      title: "Assistant EBB-SHOP",
      subtitle: "Conseiller équestre",
      placeholder: "Posez votre question...",
      greeting: "Bonjour ! 🐴 Je suis l'assistant EBB-SHOP. Comment puis-je vous aider aujourd'hui ?",
      error: "Désolé, une erreur s'est produite. Veuillez réessayer.",
      clear: "Effacer",
      poweredBy: "Propulsé par IA"
    },
    // Reviews
    reviews: {
      title: "Avis Clients",
      writeReview: "Écrire un avis",
      rating: "Note",
      reviewTitle: "Titre",
      comment: "Commentaire",
      submit: "Publier",
      verifiedPurchase: "Achat vérifié",
      helpful: "Utile",
      noReviews: "Aucun avis pour le moment. Soyez le premier !",
      loginToReview: "Connectez-vous pour laisser un avis (achat vérifié requis)",
      thankYou: "Merci pour votre avis !",
      titlePlaceholder: "Résumez votre avis",
      commentPlaceholder: "Partagez votre expérience avec ce produit..."
    },
    // Newsletter
    newsletter: {
      title: "Rejoignez la communauté EBB",
      subtitle: "Inscrivez-vous pour recevoir nos offres exclusives et les dernières nouveautés.",
      discount: "-10% sur votre première commande",
      alreadySubscribed: "Vous êtes déjà inscrit !",
      thankYou: "Merci !",
      confirmation: "Vous recevrez bientôt nos offres exclusives.",
      privacy: "En vous inscrivant, vous acceptez notre politique de confidentialité."
    }
  },
  nl: {
    // Navigation
    nav: {
      home: "Home",
      shop: "Winkel",
      sweaters: "Truien",
      hoodies: "Hoodies",
      tshirts: "T-Shirts",
      jackets: "Jassen",
      about: "Over ons",
      contact: "Contact",
      sizeGuide: "Maattabel",
      cart: "Winkelwagen",
      admin: "Admin"
    },
    // Hero
    hero: {
      title: "Elegante Ruitermode",
      subtitle: "Premium kleding voor gepassioneerde ruiters",
      cta: "Ontdek de collectie",
      freeShipping: "Gratis verzending vanaf €75"
    },
    // Products
    products: {
      featured: "Uitgelichte producten",
      newArrivals: "Nieuw binnen",
      allProducts: "Alle producten",
      addToCart: "In winkelwagen",
      outOfStock: "Uitverkocht",
      size: "Maat",
      color: "Kleur",
      quantity: "Aantal",
      material: "Materiaal",
      care: "Verzorging",
      inStock: "Op voorraad",
      price: "Prijs",
      originalPrice: "Originele prijs",
      sale: "Sale",
      new: "Nieuw",
      filterBy: "Filteren op",
      sortBy: "Sorteren op",
      priceRange: "Prijsklasse",
      clearFilters: "Filters wissen",
      noProducts: "Geen producten gevonden",
      viewDetails: "Details bekijken"
    },
    // Cart
    cart: {
      title: "Uw Winkelwagen",
      empty: "Uw winkelwagen is leeg",
      continueShopping: "Verder winkelen",
      subtotal: "Subtotaal",
      shipping: "Verzending",
      freeShipping: "Gratis",
      total: "Totaal",
      checkout: "Afrekenen",
      remove: "Verwijderen",
      updateQuantity: "Aantal wijzigen"
    },
    // Checkout
    checkout: {
      title: "Bestelling afronden",
      customerInfo: "Persoonlijke gegevens",
      shippingAddress: "Verzendadres",
      firstName: "Voornaam",
      lastName: "Achternaam",
      email: "E-mail",
      phone: "Telefoon",
      address: "Adres",
      city: "Stad",
      postalCode: "Postcode",
      country: "Land",
      belgium: "België",
      france: "Frankrijk",
      netherlands: "Nederland",
      orderSummary: "Overzicht",
      placeOrder: "Bestelling bevestigen",
      paymentMethod: "Betaalmethode",
      qrPayment: "Betaling via QR-code",
      qrInstructions: "Scan de QR-code met uw bank-app om de betaling te voltooien.",
      orderConfirmed: "Bestelling bevestigd!",
      orderNumber: "Bestelnummer",
      thankYou: "Bedankt voor uw bestelling!",
      paymentPending: "Wacht op betaling",
      bankDetails: "Bankgegevens",
      reference: "Referentie",
      iban: "IBAN",
      bic: "BIC",
      accountHolder: "Rekeninghouder"
    },
    // About
    about: {
      title: "Ons Verhaal",
      subtitle: "Passie voor paardensport sinds 2020",
      story: "EBB-SHOP is ontstaan uit passie voor paardrijden en de wens om ruiters kleding te bieden die elegantie, comfort en kwaliteit combineert. Elk stuk is ontworpen om ruiters te begeleiden in hun dagelijks leven, of het nu in de stal, op wedstrijd of tijdens een ritje is.",
      values: "Onze Waarden",
      quality: "Premium Kwaliteit",
      qualityDesc: "Zorgvuldig geselecteerde materialen voor optimaal comfort.",
      passion: "Ruiterpassie",
      passionDesc: "Gemaakt door ruiters, voor ruiters.",
      eco: "Milieuvriendelijk",
      ecoDesc: "Toewijding aan duurzamere mode."
    },
    // Contact
    contact: {
      title: "Neem contact op",
      subtitle: "Heeft u een vraag? Wij helpen u graag.",
      name: "Naam",
      email: "E-mail",
      subject: "Onderwerp",
      message: "Bericht",
      send: "Verzenden",
      phone: "Telefoon",
      address: "Adres",
      hours: "Openingstijden",
      hoursValue: "Ma-Vr: 9u-18u"
    },
    // Size Guide
    sizeGuide: {
      title: "Maattabel",
      subtitle: "Vind uw ideale maat",
      howToMeasure: "Hoe meet u zichzelf",
      chest: "Borstomtrek",
      waist: "Tailleomtrek",
      hips: "Heupomtrek",
      tip: "Tip: Bij twijfel tussen twee maten, kies de grotere maat voor meer comfort."
    },
    // Footer
    footer: {
      description: "Kwaliteitskleding voor gepassioneerde ruiters.",
      quickLinks: "Snelle links",
      customerService: "Klantenservice",
      followUs: "Volg ons",
      newsletter: "Nieuwsbrief",
      newsletterPlaceholder: "Uw e-mail",
      subscribe: "Abonneren",
      rights: "Alle rechten voorbehouden",
      privacy: "Privacybeleid",
      terms: "Algemene voorwaarden",
      returns: "Retour & Ruilen"
    },
    // Admin
    admin: {
      title: "Administratie",
      dashboard: "Dashboard",
      products: "Producten",
      orders: "Bestellingen",
      settings: "Instellingen",
      paymentSettings: "Betalingsinstellingen",
      siteSettings: "Site instellingen",
      addProduct: "Product toevoegen",
      editProduct: "Product bewerken",
      deleteProduct: "Verwijderen",
      confirmDelete: "Weet u zeker dat u dit product wilt verwijderen?",
      save: "Opslaan",
      cancel: "Annuleren",
      bankName: "Banknaam",
      status: "Status",
      stockAlerts: "Voorraadwaarschuwingen",
      lowStock: "Lage voorraad",
      outOfStock: "Uitverkocht",
      orderStatus: {
        pending: "In afwachting",
        paid: "Betaald",
        processing: "In verwerking",
        shipped: "Verzonden",
        delivered: "Geleverd",
        cancelled: "Geannuleerd"
      }
    },
    // Auth & Account
    auth: {
      login: "Inloggen",
      register: "Registreren",
      logout: "Uitloggen",
      email: "E-mail",
      password: "Wachtwoord",
      confirmPassword: "Bevestig wachtwoord",
      forgotPassword: "Wachtwoord vergeten?",
      noAccount: "Nog geen account?",
      hasAccount: "Al een account?",
      createAccount: "Account maken",
      loginSuccess: "Inloggen gelukt!",
      registerSuccess: "Registratie gelukt!",
      invalidCredentials: "Ongeldige e-mail of wachtwoord"
    },
    account: {
      title: "Mijn Account",
      profile: "Profiel",
      orders: "Mijn Bestellingen",
      addresses: "Adressen",
      wishlist: "Verlanglijst",
      loyalty: "Loyaliteitsprogramma",
      editProfile: "Profiel bewerken",
      addAddress: "Adres toevoegen",
      defaultAddress: "Standaard adres",
      noOrders: "U heeft nog geen bestellingen",
      orderDetails: "Besteldetails"
    },
    // Loyalty
    loyalty: {
      title: "Loyaliteitsprogramma",
      points: "Punten",
      level: "Niveau",
      bronze: "Brons",
      silver: "Zilver",
      gold: "Goud",
      discount: "Korting",
      pointsToNext: "Punten voor volgend niveau",
      earnPoints: "Verdien 1 punt per euro besteed",
      benefits: "Voordelen",
      bronzeBenefit: "Toegang tot exclusieve aanbiedingen",
      silverBenefit: "5% korting op alle bestellingen",
      goldBenefit: "10% korting + gratis verzending"
    },
    // Wishlist
    wishlist: {
      title: "Mijn Verlanglijst",
      empty: "Uw verlanglijst is leeg",
      addedToWishlist: "Toegevoegd aan verlanglijst",
      removedFromWishlist: "Verwijderd uit verlanglijst",
      moveToCart: "Toevoegen aan winkelwagen"
    },
    // Common
    common: {
      loading: "Laden...",
      error: "Er is een fout opgetreden",
      success: "Succes",
      close: "Sluiten",
      back: "Terug",
      next: "Volgende",
      previous: "Vorige",
      search: "Zoeken",
      language: "Taal"
    },
    // Chatbot
    chatbot: {
      title: "EBB-SHOP Assistent",
      subtitle: "Ruiter adviseur",
      placeholder: "Stel uw vraag...",
      greeting: "Hallo! 🐴 Ik ben de EBB-SHOP assistent. Hoe kan ik u vandaag helpen?",
      error: "Sorry, er is een fout opgetreden. Probeer het opnieuw.",
      clear: "Wissen",
      poweredBy: "Aangedreven door AI"
    },
    // Reviews
    reviews: {
      title: "Klantbeoordelingen",
      writeReview: "Schrijf een beoordeling",
      rating: "Score",
      reviewTitle: "Titel",
      comment: "Opmerking",
      submit: "Publiceren",
      verifiedPurchase: "Geverifieerde aankoop",
      helpful: "Nuttig",
      noReviews: "Nog geen beoordelingen. Wees de eerste!",
      loginToReview: "Log in om een beoordeling te schrijven (geverifieerde aankoop vereist)",
      thankYou: "Bedankt voor uw beoordeling!",
      titlePlaceholder: "Vat uw mening samen",
      commentPlaceholder: "Deel uw ervaring met dit product..."
    },
    // Newsletter
    newsletter: {
      title: "Word lid van de EBB community",
      subtitle: "Schrijf u in om onze exclusieve aanbiedingen en laatste nieuwtjes te ontvangen.",
      discount: "-10% op uw eerste bestelling",
      alreadySubscribed: "U bent al ingeschreven!",
      thankYou: "Bedankt!",
      confirmation: "U ontvangt binnenkort onze exclusieve aanbiedingen.",
      privacy: "Door u in te schrijven, gaat u akkoord met ons privacybeleid."
    }
  }
};

export default translations;
